/**
 * Extracts the error message from an API response error object.
 * @param error - The API response error object.
 * @returns The error message extracted from the API response error object, or the error message itself if not found.
 */
export const getErrorMsgFromAPIResponse = (error: any) => {
  const errMessage = error?.error?.message || error.message;
  return errMessage;
};
